export const GROUPS_START = "GET_GROUPS_START";
export const GET_GROUPS_SUCCESS = "GET_GROUPS_SUCCESS";
export const GROUPS_FAIL = "GROUPS_FAIL";
export const GROUPS_DELETE_SUCCESS = "GROUPS_DELETE_SUCCESS";

export const ADD_NEW_GROUP_SUCCESS = "ADD_NEW_GROUP_SUCCESS";

export const SAVE_GROUP_FILTER = "SAVE_GROUP_FILTER";

export const EDIT_GROUP = "EDIT_GROUP";

export const SELECTED_GROUP = "SELECTED_GROUP";

export const EMPTY_GROUPS = "EMPTY_GROUPS";
